import React from "react";
import SideMenu from "../../../shared/components/app/SideMenu";
import Button from "../../../shared/components/ui/Button";
import { Box } from "../../../shared/components/ui/chakra";
import SmsIcon from "../../../shared/components/icons/SmsIcon";
import useRequest from "../../../shared/lib/useRequest";
import useFlash from "../../../shared/lib/useFlash";
import { SharedApprovedCurrentUser } from "../../../shared/lib/types";
import { businessMatchingOwnedBusinessEntityTalkRoomsPath } from "../../../../../routes";
import { BusinessEntity } from "../lib/types";
import { useForm } from "react-hook-form";

import { Stack } from "@chakra-ui/react";

const BusinessEntitySideMenu = ({
  businessEntity,
  preview = false,
  currentUser,
}: {
  businessEntity: Pick<BusinessEntity, "code" | "use_case" | "is_own"> & {
    contractor_info: Pick<
      NonNullable<BusinessEntity["contractor_info"]>,
      "architectural_design_works"
    > | null;
  };
  preview?: boolean;
  currentUser?: SharedApprovedCurrentUser;
}) => {
  const request = useRequest();
  const showFlash = useFlash();
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();

  const focus = (id: string) => {
    const element = document.querySelector(id);
    if (element) {
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - 140,
        behavior: "smooth",
      })
    }
  };

  const redirectToTalkRoom = async () => {
    if (currentUser == null || businessEntity == null) return;

    const currentBusinessEntityCode =
      currentUser?.owned_business_entities?.current.code;

    if (!currentBusinessEntityCode) {
      return;
    }

    const res = await request(
      businessMatchingOwnedBusinessEntityTalkRoomsPath(
        currentBusinessEntityCode,
      ),
      "POST",
      {
        partner_code: businessEntity.code,
      },
    );
    if (res.ok) {
      const json = (await res.json()) as { talk_room_code: string };
      window.open(
        businessMatchingOwnedBusinessEntityTalkRoomsPath(
          currentBusinessEntityCode,
          { code: json.talk_room_code },
        ),
        "_blank",
      );
    } else if (res.status === 404) {
      showFlash({
        error: (
          <>
            事業者が見つかりませんでした。
            <br />
            ページをリロードしてください。
          </>
        ),
      });
    }
  };

  const showWorks = !!(
    (businessEntity.use_case === "contractor" ||
      businessEntity.use_case === "both") &&
    businessEntity.contractor_info &&
    businessEntity.contractor_info.architectural_design_works.length > 0
  );

  return (
    <Stack gap={4}>
      <Box backgroundColor={"#ffffff"} p={4} borderRadius={"8px"}>
        <SideMenu
          items={[
            {
              label: "事業者概要",
              onClick: () => focus("#summary"),
            },
            {
              label: "業務の希望条件",
              onClick: () => focus("#conditions"),
            },
            showWorks
              ? {
                  label: "設計事例・実績",
                  onClick: () => focus("#works"),
                }
              : null,
            {
              label: "事業者情報",
              onClick: () => focus("#business-entity-info"),
            },
          ].filter((v) => v !== null)}
        />
      </Box>
      {businessEntity && !businessEntity.is_own && currentUser && (
        <Button
          leftIcon={<SmsIcon boxSize={5} />}
          {...(preview ? {} : { as: "a", href: "" })}
          onClick={handleSubmit(redirectToTalkRoom)}
          isDisabled={isSubmitting}
        >
          お問い合わせする
        </Button>
      )}
    </Stack>
  );
};

export default BusinessEntitySideMenu;
